export default {
  setting: {
    profileAuthSetting: "Configuração de Autenticação de Perfil",
    logInOutSetting: "Configurações de Login/Logoff",
    autoLogout: "Logoff Automático",
    unsuccessfulLoginAttempt: "Unsuccessful Login Attemps",
    unsuccessfulLoginLockPeriod: "Tentativas malsucedidas de login",
    passCriteriaSetup: "Regras de senha",
    passLength: "Tamanho da senha",
    noUniquePassRequired: "Numero de senhas únicas exigidos",
    maxPassAge: "Idade máxima da senha",
    acceptableRangeOfChars: "Faixa de caracteres aceitável",
    upperCase: "Maiúscula",
    lowerCase: "Minúscula",
    numbers: "Números",
    specialChars: "Caracteres Especiais",
    uniqueSymbols: "Simbolos Únicos",
    loadingData: "Carregando dados...",
    currency: "Moeda",
    codeActivationTime: "Tempo de ativação do código",
    changeGlobalSetting: "Alterar configurações globais",
    globalSetting: "Alterar configurações globais",
    generalSetting: "Configurações Gerais",
    hour: "Horas",
    days: "Dias",
    minutes: "Minutos",
    perDay: "Por dia",
    perHour: "Por hora",
    customised: "Personalizado",
    areaUnit: "Unidade de Área",
    weightUnit: "Unidade de Peso",

    smallFarm: "Pequena fazenda",
    inclusive: "Inclusivo",
    from: "De",
    to: "Para",
    mediumFarm: "Fazenda média",
    largeFarm: "Grande fazenda",
    requiredMessage: "Este campo é obrigatório",
    nonNegativeMessage: "Este campo deve ser não negativo",
    fieldToGreaterThanFrom: "Este campo deve ser maior que o campo 'De'",
    fieldToGreaterThanFromMedium: "Este campo deve ser maior que o campo 'Para' da pequena fazenda",
    fieldToGreaterThanMediumTo: "Este campo deve ser maior que o campo 'Para' da fazenda média",

    farmSettings: "Configurações da Fazenda",
    profileSettings: "Configurações de Perfil",
    enterpriseSettings: "Configurações de Empresa",
    coffeeSettings: "Configurações de Café",
    cropVarietySettings: "Configurações de Variedades de Culturas",
    cropVarietyName: "Nome da Variedade de Cultura",
    cropType: "Tipo de Cultura",
    addCropVariety: "Adicionar Nova Variedade de Cultura",
    editCropVariety: "Editar Variedade de Cultura",
    deleteCropVariety: "Excluir Variedade de Cultura",
    deleteCropVarietyConfirm: "Tem certeza que deseja excluir esta variedade de cultura? Esta ação não pode ser desfeita.",
    cropVarietyDesc: "Gerencie as variedades de culturas e seus tipos associados para sua organização.",
  },
}